module.exports = "/wwwroot/img/facebook-f-brands.svg?ver=d78179a2";